
window.addEventListener('DOMContentLoaded', (event) => {
	subMenu();
});

let menuToggle = document.getElementById('menu-toggle');
let closeButton = document.getElementById('menu-close');

//display/hide mobile menu
menuToggle.addEventListener('click', () => {
	let menuContainer = document.getElementById('menu-primary');
	menuContainer.classList.toggle('hidden');
	menuToggle.classList.toggle('open');
})
if (closeButton != null) {
	closeButton.addEventListener('click', () => {
		let menuContainer = document.getElementById('menu-primary');
		menuContainer.classList.toggle('hidden');
	})
}

let menuItems = document.getElementsByClassName('has-children');
let buttons = document.getElementsByClassName('has-children');

//display/hide sub menus
function subMenu () {
	for (let i = 0; i < buttons.length; i++) {
		let button = buttons[i];

		let subMenu = button.getElementsByClassName('menu__sub-menu')[0];

		button.addEventListener('mouseover', () => {
			if (button.classList.contains('close')) {
				button.classList.remove('close');
				button.classList.add('open');
				subMenu.style.display = "flex";
			}
		})

		button.addEventListener('mouseout', () => {
			if (button.classList.contains('open')) {
				button.classList.remove('open');
				button.classList.add('close');
				subMenu.style.display = "none";
			}
		})

		button.addEventListener('click', () => {
			if (button.classList.contains('open')) {
				button.classList.remove('open');
				button.classList.add('close');
				subMenu.style.display = "none";
			} else {
				closeOtherMenus();
				button.classList.add('open');
				button.classList.remove('close');
				subMenu.style.display = "flex";

			}
		})
	}
}


function closeOtherMenus() {
	for (let i = 0; i < menuItems.length; i++) {
		if (menuItems[i].classList.contains('open')) {
			menuItems[i].classList.remove('open');
			menuItems[i].classList.add('close');
			menuItems[i].getElementsByClassName('menu__sub-menu')[0].style.display = 'none';
		}
	}
}
